export default __webpack_public_path__ + "static/media/Android.f5066188.svg";